export default function NotFound() {

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">There is no invoice with this ID</h1>
        <p className="mt-4 text-lg md:text-xl text-gray-500">Please make sure your invoice ID is correct.
        </p>
      </div>
    </div>
  );
}
